import React, { Component } from "react";
import EventTile from "../../../../components/page/event/event-tile/event.tile.component";
import { public_event_list } from "../../public.api";
import moment from "moment";

class HomeEvents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      url: "",
    };
  }

  componentDidMount() {
    this.fetchEvent();
  }

  fetchEvent = () => {
    public_event_list().then((res) => {
      this.setState({
        data: res.data,
        url: res.current_url,
      });
    });
  };

  mangeViewMore = () => {
    sessionStorage.setItem("continueFrom", "events");
    this.props.history.push("/events");
  };

  render() {
    const { data, url } = this.state;
    const lang = this.props.state?.language || "en";

    const fData = data?.filter((item) =>
      moment(item?.[lang]?.eventDate, "DD-MM-YYYY").isSameOrAfter(
        moment(),
        "day"
      )
    );
    console.log(fData, moment().toDate());
    return (
      <>
        {fData?.length > 0 ? (
          <>
            <div className="events-section">
              <div className="event-tile-container">
                {fData.slice(0, 3).map((item, index) => (
                  <EventTile
                    key={item[lang]?.uuid || index}
                    {...this.props}
                    data={item}
                    url={url}
                    fromHome={true}
                  />
                ))}
              </div>
            </div>
            <div className="pad-50">
              <div className="all-to-center ">
                <button
                  className="read-more-btn-gallery"
                  onClick={this.mangeViewMore}
                >
                  All events
                </button>
              </div>
            </div>
          </>
        ) : (
          <>No Upcoming Events</>
        )}
      </>
    );
  }
}

export default HomeEvents;
